/**
 * UnderwriterLayout - Enterprise Underwriter Portal Layout
 * Uses shared AppLayout for consistency
 */
import { useState } from 'react';
import { useNavigate, Outlet } from 'react-router';
import { AppLayout } from '../../components/layout';
import { UNDERWRITER_NAV } from '../../config/navigation';
import { authService } from '../../services/supabaseService';


// Underwriter configuration (would come from logged-in user profile)
const UNDERWRITER_CONFIG = {
  name: 'Sarah Mitchell',
  email: 'sarah.mitchell@loanknow.com',
  capacity: 25,
};

const UnderwriterLayout = () => {
  const navigate = useNavigate();
  const [pipelineCount, setPipelineCount] = useState(0);

  const handleLogout = async () => {
    await authService.signOut();
    navigate('/uw/login');
  };


  const capacityUsed = (pipelineCount / UNDERWRITER_CONFIG.capacity) * 100;

  return (
    <AppLayout
      role="underwriter"
      navItems={UNDERWRITER_NAV}
      user={{
        name: UNDERWRITER_CONFIG.name,
        email: UNDERWRITER_CONFIG.email,
        role: 'underwriter',
        capacity: UNDERWRITER_CONFIG.capacity,
        pipelineCount: pipelineCount,
        capacityUsed: capacityUsed,
      }}
      onLogout={handleLogout}
    >
      <Outlet context={{ setPipelineCount }} />
    </AppLayout>
  );
};

export default UnderwriterLayout;
